<template>
  <div class="companies">
    <SectionHeader :title="$t('sites.sites')">
      <template v-slot:meta>
        <Link :to="`/company/sites/new`" class="button button-green button-round button-small"
          >{{ $t('sites.addSite') }}
        </Link>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <LinkList>
          <LinkListItem v-for="site in sites" :primaryLink="`/company/sites/${site.uuid}`" :key="site.uuid">
            <template #main-content>
              <span>{{ site.name }}</span>
            </template>
            <template #action-content>
              <Link :to="`/company/sites/${site.uuid}`" class="link-list-item__action">
                <span class="material-icons">edit</span>
              </Link>

              <button
                @click.prevent="deleteSite(site)"
                :disabled="!site.can_be_deleted"
                :title="deleteButtonText(site)"
                class="link-list-item__action"
              >
                <span class="material-icons">delete</span>
              </button>
            </template>
          </LinkListItem>
        </LinkList>
      </div>
    </div>
  </div>
</template>

<script>
import LinkListItem from '@/components/LinkList/LinkListItem.vue'
import LinkList from '@/components/LinkList/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import sitesApi from '@/api/sites'

export default {
  name: 'company_sites',
  inject: ['companyUser', 'showPopup'],
  data: () => ({
    sites: [],
  }),
  components: {
    CompanyNav,
    SectionHeader,
    LinkList,
    LinkListItem,
  },
  methods: {
    async deleteSite(site) {
      if (await this.showPopup({ content: this.$t('sites.deleteConfirmation'), type: 'confirm' })) {
        const response = await sitesApi.delete(site.uuid)
        if (response.success) {
          this.getSites()
        }
      }
    },
    async getSites() {
      this.sites = await sitesApi.getAllForCompany(this.companyUser.company_uuid)
    },
    deleteButtonText(site) {
      if (!site.can_be_deleted) {
        return this.$t('sites.cannotBeDeleted')
      }
    },
  },
  mounted() {
    this.getSites()
  },
}
</script>
